import { ExternalToast, toast } from "sonner";
import colors from "../utils/colors";

const showSuccessNotification = (message: string, options?: ExternalToast) => {
  toast.success(message, {
    ...options,
    style: {
      backgroundColor: colors.backgroundMain,
      color: colors.theme,
      borderColor: "transparent",
    },
  });
};

const showWarningNotification = (message: string, options?: ExternalToast) => {
  toast.warning(message, options);
};

const showErrorNotification = (error: string, options?: ExternalToast) => {
  toast.error(error, options);
};

const showOnceADayAlert = (message: string, options?: ExternalToast) => {
  const lastAlertDateString = localStorage.getItem("lastAlertDate");

  if (lastAlertDateString) {
    const currentDate = new Date();
    const lastAlertDate = new Date(lastAlertDateString);

    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const timeDifference = currentDate.getTime() - lastAlertDate.getTime();

    if (timeDifference >= oneDayInMilliseconds) {
      toast.warning(message, {
        ...options,
      });
      localStorage.setItem("lastAlertDate", currentDate.toISOString());
    }
  } else {
    toast.warning(message, {
      ...options,
    });
    localStorage.setItem("lastAlertDate", new Date().toISOString());
  }
};

export {
  showSuccessNotification,
  showWarningNotification,
  showErrorNotification,
  showOnceADayAlert,
};
